import { render } from "./newShedVdmCopy.vue?vue&type=template&id=557d56b6&scoped=true"
import script from "./newShedVdmCopy.vue?vue&type=script&lang=js"
export * from "./newShedVdmCopy.vue?vue&type=script&lang=js"

import "./newShedVdmCopy.vue?vue&type=style&index=0&id=557d56b6&lang=scss&scoped=true"
import "./newShedVdmCopy.vue?vue&type=style&index=1&id=557d56b6&lang=scss&scoped=true"
import "./newShedVdmCopy.vue?vue&type=style&index=2&id=557d56b6&lang=scss&scoped=true"
import "./newShedVdmCopy.vue?vue&type=style&index=3&id=557d56b6&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557d56b6"]])

export default __exports__